import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Le conteneur dans lequel toutes les notifications sont rendues.
 *
 * Il vit directement sous <body>, hors de toute carte, modale ou conteneur en
 * `overflow: hidden`. C'est ce qui permet à un toast de rester visible quel que
 * soit l'écran qui l'a déclenché : un toast rendu au milieu de l'arbre se
 * retrouve prisonnier du contexte d'empilement de ses parents, et passe sous
 * l'assombrissement du premier dialogue venu, si haut que soit son z-index.
 */
export const getToastRoot = () => {
  let portalRoot = document.getElementById('toast-root');
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.id = 'toast-root';
    document.body.appendChild(portalRoot);
  }
  return portalRoot;
};

const ToastPortal = ({ children }) => ReactDOM.createPortal(children, getToastRoot());

export default ToastPortal;
